import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/admin/partner-commission/assisted-registrations";

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (isSuccess === false) {
    return {
      isSuccess: false,
      data: null,
      message: res?.message ?? res?.Message ?? fallbackMessage,
      statusCode: res?.statusCode ?? res?.StatusCode,
    };
  }
  return {
    isSuccess: true,
    data: res?.data ?? res?.Data ?? null,
    message: res?.message ?? res?.Message,
  };
};

const AssistedRegistrationExpertApi = {
  getQueue: async () => {
    const response = await api.request({
      url: `${BASE}/expert-review-queue`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت صف بررسی ناموفق بود.");
  },

  approve: async (leadId) => {
    const response = await api.request({
      url: `${BASE}/${leadId}/expert-review/approve`,
      method: "POST",
      headers: authHeader(),
    });
    return normalize(response.data, "تأیید بررسی اولیه ناموفق بود.");
  },

  requestCorrection: async (payload) => {
    const response = await api.request({
      url: `${BASE}/expert-review/request-correction`,
      method: "POST",
      data: payload,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "ثبت درخواست اصلاح ناموفق بود.");
  },
};

export const CORRECTABLE_FIELD_OPTIONS = [
  { key: "firstName", label: "نام" },
  { key: "lastName", label: "نام خانوادگی" },
  { key: "nationalCode", label: "کد ملی" },
  { key: "email", label: "ایمیل" },
  { key: "address", label: "آدرس" },
  { key: "postalCode", label: "کد پستی" },
  { key: "telephon", label: "تلفن" },
  { key: "locationInput", label: "موقعیت (لینک/مختصات)" },
  { key: "electricBoillNumber", label: "شماره قبض برق" },
  { key: "electricBoillUrl", label: "فایل قبض برق" },
  { key: "homeOwnerShipDocUrl", label: "سند مالکیت" },
  { key: "note", label: "توضیحات" },
  { key: "plantCapacity", label: "ظرفیت" },
  { key: "installationType", label: "نوع نصب" },
];

export default AssistedRegistrationExpertApi;
